import * as React from 'react';
import debounce from 'lodash.debounce';
import Box from '@mui/material/Box';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import TextField from "@mui/material/TextField";
import Skeleton from '@mui/material/Skeleton';
import { useEffect, useState, useMemo } from 'react';
import { useDispatch, useSelector } from "react-redux";
import SearchIcon from '@mui/icons-material/Search';
import { Grid, InputAdornment, Stack } from '@mui/material';
import SearchListGrid from '../searchListGrid/SearchListGrid';
import {
    getLoadersListSelector, getLoaderSelector, getLoadersListPendingSelector, deleteLoaderPendingSelector, deleteLoaderSelector
} from "../../../store/dataLoader/selectors";
import * as workflows from '../../../store/workFlows/actions'
import {
    fetchLoaderDetailsReq,
    fetchLoadersReq,
} from "../../../store/dataLoader/actions";
import { IDataLoader, IFetchDataLoaderDetails, ISearchParam, IDeleteParams } from '../../../store/dataLoader/types';
import { HeadCell, Order } from '../tableGrid/types';
import EnhancedTable from '../tableGrid/tableGrid';
import EnhancedTableToolbar from '../tableGrid/tableToolbar';
import EnhancedTableHead from '../tableGrid/tableHead';
import Row from '../tableGrid/tableRow';
import { useNavigate } from 'react-router-dom';
import { deleteLoaderReq } from '../../../store/dataLoader/actions'
import { Button } from '@mui/material';
import { getProfileDataSelector } from '../../../store/auth/selectors';
import CustomizedDialogs from '../../atoms/modal/customizedDialogs';
import { SEARCH_DEBOUNCE_TIME_MILLIS } from '../../../constants/common';
import { OverridableStringUnion } from "@mui/types";

// settings data

const headCells: HeadCell[] = [
    {
        id: 'inactive',
        numeric: false,
        disablePadding: false,
        label: '',
        width: "25px",
        disableSort: true
    },
    {
        id: "selected",
        numeric: false,
        disablePadding: true,
        label: "",
        width: "5px",
    },
    {
        id: 'description',
        numeric: false,
        disablePadding: false,
        label: 'Name',
        width: '250px'
    },
    {
        id: 'tableSchema',
        numeric: false,
        disablePadding: false,
        label: 'Schema',
        width: '300px'
    },
    {
        id: 'tableName',
        numeric: false,
        disablePadding: false,
        label: 'Table',
        width: '350px'
    },
    {
        id: 'owner',
        numeric: false,
        disablePadding: false,
        label: 'Owner',
        width: '250px'
    },

];

const headCellsAlt: HeadCell[] = [
    {
        id: 'inactive',
        numeric: false,
        disablePadding: false,
        label: '',
        width: "25px",
        disableSort: true
    },
    {
        id: 'description',
        numeric: false,
        disablePadding: false,
        label: 'Name',
        width: '25px'
    },
    {
        id: 'tableSchema',
        numeric: false,
        disablePadding: false,
        label: 'Schema',
        width: '5px'
    },
    {
        id: 'tableName',
        numeric: false,
        disablePadding: false,
        label: 'Table',
        width: '35px'
    },
    {
        id: 'owner',
        numeric: false,
        disablePadding: false,
        label: 'Owner',
        width: '15px'
    },

];


const filterCells: string[] = [
    'owner',
    'targetLayerName',
]

// end

const descendingComparator = (a: IDataLoader, b: IDataLoader, orderBy: keyof IDataLoader) => {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

const getComparator = (order: Order, orderBy: keyof IDataLoader): (
    a: IDataLoader,
    b: IDataLoader,
) => number => {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
};

export type LoaderExplorerProps = {
    selectable: string;
    selectorField?: string;
    selectedValue?: any;
    onSelect?: any;
    personal?: boolean;
    targetName?: string;
    extractorBatchCode?: string;
    isAdmin?: boolean;
    displayActionButtons: boolean
}


const LoaderExplorer = (props: LoaderExplorerProps) => {

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [dataRows, setDataRows] = useState<IDataLoader[]>([]);
    const [totalRows, setTotalRows] = useState(0);
    const [order, setOrder] = useState<Order>("asc");
    const [orderBy, setOrderBy] = useState<keyof IDataLoader>("description");
    const [rowDetails, setRowDetails] = useState<IFetchDataLoaderDetails[]>([]);
    const [selected, setSelected] = useState<readonly string[]>(props.selectedValue === undefined ? [] : [props.selectedValue]);
    const selectorField: string = props.selectorField ? props.selectorField : 'batchCode'
    const selectable: string = props.selectable;
    const allSelectable: boolean = false;
    const [open, setOpen] = useState(false);
    const [rowName, setRowName] = useState('');
    const [loaderBatchCode, setLoaderBatchCode] = useState('');
    const [searchTerm, setSearchTerm] = useState('');
    const [personalView, setPersonalView] = useState(props.personal === undefined ? false : props.personal);
    const [isDeletePopup, setIsDeletePopup] = useState(false)
    const [isRunPopup, setIsRunPopup] = useState(false)
    const [deletedIds, setDeletedIds] = useState<string[]>([]);
    const [isRebaseAllowed, setIsRebaseAllowed] = useState(false);


    // Filters-related
    const [owners, setOwners] = useState<string[]>([]);
    const [targetLayerNames, setTargetLayerNames] = useState<string[]>([]);
    const [extBatchCode, setExtBatchCode] = useState<string>('');
    const [filters, setFilters] = useState<string[]>([]);
    const [openFilters, setOpenFilters] = useState(false);
    const [deletedIdLoading, setDeletedIdLoading] = useState('')

    const dispatch = useDispatch();
    const navigate = useNavigate();


    // Loader list   
    const loaderList = useSelector(getLoadersListSelector);
    const loadingLoaderList = useSelector(getLoadersListPendingSelector)
    const loaderDetail = useSelector(getLoaderSelector);
    // current user
    const userProfile = useSelector(getProfileDataSelector);

    // delete loader 
    const deleteLoaderStatus = useSelector(deleteLoaderSelector);
    const deletePending = useSelector(deleteLoaderPendingSelector)

    const [mail, setMail] = useState("")
    const params: ISearchParam = {
        skip: page * rowsPerPage,
        top: rowsPerPage,
        count: true,
        search: searchTerm,
        owner: owners,
        targetLayerName: targetLayerNames,
        orderby: `${orderBy} ${order}`,
    };

    useEffect(() => {

        if (!userProfile) {
            return;
        }

        if (personalView) {
            setOwners([userProfile['userPrincipalName']]);
        } else if (owners.length > 0) {
            setOwners([])
        }

    }, [userProfile]);

    useEffect(() => {

        // When target name is available, use as filter

        if (props.targetName) {
            let tn = targetLayerNames.concat(props.targetName);
            setTargetLayerNames(tn);
        }
        else if (props.extractorBatchCode) {
            setSearchTerm(props.extractorBatchCode.replace(/:/g, ''));
        }

    }, []);

    useEffect(() => {
        if (personalView && owners.length < 1) {
            return;
        }
        window.scrollTo(0, 0)
        dispatch(fetchLoadersReq(params));
    }, [page, rowsPerPage, searchTerm, owners, targetLayerNames, extBatchCode, orderBy, order]);

    function enableStatus(enabled: boolean): OverridableStringUnion<'disabled' | 'success'> {
        if (enabled) {
            return "success";
        } else {
            return "disabled";
        }
    }

    useEffect(() => {

        let data: IDataLoader[] = loaderList.loaders;
        if (data && data.length > 0) {
            const newData = data.map((item: IDataLoader, index: number) => {
                const status = item.enabled === null && item.taskId === null ? true : item.enabled;
                return {
                    ...item,
                    inactive: enableStatus(status),
                    index
                };
            })
            setDataRows(newData);
        }
        else {
            setDataRows(data);
        }
        setTotalRows(loaderList.count);

    }, [loaderList]);

    useEffect(() => {

        let isDetailExists = false;
        if (loaderDetail) {
            isDetailExists = rowDetails.filter((x) => x && x.batchCode === loaderDetail!.batchCode).length > 0;
            if (!isDetailExists) {
                setRowDetails([...rowDetails, loaderDetail!]);
            }
        }

    }, [loaderDetail, rowDetails]);

    // table related events 

    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleRequestSort = (
        event: React.MouseEvent<unknown>,
        property: string,
    ) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property as keyof IDataLoader);
    };

    const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.checked) {
            const newSelecteds = dataRows.map((n: { description: any; }) => n.description);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };

    const deleteAllClick = () => {
        setSelected([]);
    }

    const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
        setPage(0);
        setSearchTerm(e.target.value)

    }

    const handleSearchDebounce = useMemo(() => {
        return debounce(handleSearch, SEARCH_DEBOUNCE_TIME_MILLIS);
    }, []);

    const searchEl = () => {
        return (
            <TextField
                id="loader-search"
                label="Search Loaders"
                type="search"
                fullWidth={true}
                onChange={handleSearchDebounce}
                InputProps={{
                    startAdornment: <InputAdornment position="start"><SearchIcon /></InputAdornment>,
                }}
            />
        );
    };

    const handleExpand = (row: IDataLoader) => {

        let isExist = rowDetails.find((x) => x && x.batchCode === row.loaderBatchCode);

        if (!isExist) {
            // dispatch get source details action
            dispatch(fetchLoaderDetailsReq(row.loaderBatchCode));
        }
    }

    const handleLoaderView = (row: IDataLoader, event: React.MouseEvent<HTMLButtonElement>) => {
        const batchCode = encodeURIComponent(row.loaderBatchCode);
        const url = `/ViewDataLoader/${batchCode}`;
        if (event.ctrlKey) {
            window.open(url, '_blank')
        }
        else {
            navigate(url);
        }
    }

    const handleLoaderEdit = (row: IDataLoader, event: React.MouseEvent<HTMLButtonElement>) => {
        if (props.isAdmin || row.owner.toLowerCase() === userProfile?.mail.toLowerCase()) {
            const batchCode = encodeURIComponent(row.loaderBatchCode);
            const url = `/EditDataLoader/${batchCode}`;
            if (event.ctrlKey) {
                window.open(url, '_blank')
            }
            else {
                navigate(url);
            }
        }
    }

    const handleLoaderRun = () => {
        const finalLoaderRun = {
            "batchCode": loaderBatchCode ? loaderBatchCode : '',
            "rebase": false
        }
        dispatch(workflows.postWorkFlowsRequest(finalLoaderRun));
        setOpen(false);

    }

    const handleLoaderRunRebase = () => {
        const finalLoaderRun = {
            "batchCode": loaderBatchCode ? loaderBatchCode : '',
            "rebase": true
        }
        dispatch(workflows.postWorkFlowsRequest(finalLoaderRun));
        setOpen(false);
    }

    const confirmLoaderRun = (row: IDataLoader) => {
        setOpen(true);
        setLoaderBatchCode(row.loaderBatchCode);
        setRowName(row.loaderBatchCode);
        setIsDeletePopup(false)
        setIsRunPopup(true)
        let isRebase = props.isAdmin || filterOwner(row.owner);
        setIsRebaseAllowed(isRebase);
    }

    useEffect(() => {
        if (userProfile) {
            setMail(userProfile.mail)
        }
    }, [userProfile]);

    const handleClose = () => {
        setOpen(false);
    }

    const deleteParams: IDeleteParams = {
        batchCodes: [loaderBatchCode],
    };

    const filterResults = (event: React.MouseEvent<HTMLButtonElement>, filters: string[]) => {

        let newOwners: string[] = personalView ? [userProfile['mail']] : [];
        let newTargets: string[] = [];

        filters.forEach(item => {
            let filter: string[] = item.split(": ");
            switch (filter[0]) {
                case 'owner':
                    newOwners.push(filter[1]);
                    setOwners(newOwners);
                    params.owner = newOwners;
                    break;
                case 'targetLayerName':
                    newTargets.push(filter[1]);
                    setTargetLayerNames(newTargets);
                    params.targetLayerName = newTargets;
                    break;
                default:
                    break;
            }
        });

        setFilters(filters);
        setOpenFilters(true);
        setPage(0);
    }

    const refreshPage = () => {

        personalView ? setOwners([userProfile['userPrincipalName']]) : setOwners([]);
        params.owner = personalView ? [userProfile['userPrincipalName']] : [];

        setTargetLayerNames([]);
        params.targetLayerName = [];

        setFilters([]);
        setOpenFilters(false);


        setOrder('asc')
        setOrderBy("description")
    }

    const handleLoaderDelete = () => {
        setOpen(false);
        setDeletedIds(item => [...item, deleteParams.batchCodes[0]]);
        setDeletedIdLoading(deleteParams.batchCodes[0])
        dispatch(deleteLoaderReq(deleteParams));
    }

    const confirmLoaderDelete = (row: IDataLoader) => {
        setOpen(true);
        setLoaderBatchCode(row.loaderBatchCode);
        setIsDeletePopup(true)
        setIsRunPopup(false)

    }


    const handleClick = (event: React.MouseEvent<unknown>, row: any) => {
        if (selectorField === 'taskId') {
            if (selected[0] === row.taskId) {
                setSelected([]);
                props.onSelect && props.onSelect([]);
            } else {
                setSelected([row.taskId]);
                props.onSelect && props.onSelect(row)
            }
        } else {
            if (selected[0] === row.tableId) {
                setSelected([]);
                props.onSelect && props.onSelect([]);
            } else {
                setSelected([row.tableId]);
                props.onSelect && props.onSelect(row.tableId, row.sourceId)
            }
        }

    }


    const tableToolBar = () => {
        return (
            <EnhancedTableToolbar numSelected={selected.length} title={'Data Loaders'} headCells={props.selectable === "no" ? headCellsAlt : headCells}
                filterCells={filterCells} deleteAll={deleteAllClick} filterResults={filterResults} refreshPage={refreshPage} personal={personalView}
                currentFilters={filters} openToolbar={openFilters} />
        );
    }

    const tableHeader = () => {
        return (
            <EnhancedTableHead
                headCells={props.selectable === "no" ? headCellsAlt : headCells}
                numSelected={selected.length}
                selectable={allSelectable}
                order={order}
                orderBy={orderBy}
                onSelectAllClick={handleSelectAllClick}
                onRequestSort={handleRequestSort}
                rowCount={totalRows}
            />

        );
    }

    const filterOwner = (owner: string) => {

        if (owner.toLowerCase() === mail.toLowerCase()) {
            return true
        }
        else return false
    };

    const isSelected = (name: string) => selected.indexOf(name) !== -1;

    // Avoid a layout jump when reaching the last page with empty rows.
    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - totalRows) : 0;

    const tableRows = () => {

        return (
            <>
                {dataRows?.length > 0 && dataRows.slice().sort(getComparator(order, orderBy))
                    .map((row: IDataLoader, index: number) => {
                        const isItemSelected = selectorField === 'taskId' ? isSelected(row.taskId) : isSelected(row.loaderBatchCode);
                        const details = rowDetails.find((x) => x && x.batchCode === row.loaderBatchCode);
                        const checkOwner = (row.owner != null) ? filterOwner(row.owner) : false;
                        return (
                            <Row row={row}
                                key={row.loaderBatchCode}
                                headCells={headCells}
                                selectable={selectable}
                                canEdit={props.displayActionButtons ? props.isAdmin || checkOwner ? true : false : props.displayActionButtons}
                                canView={props.displayActionButtons}
                                canDelete={props.displayActionButtons ? props.isAdmin || checkOwner ? true : false : props.displayActionButtons}
                                canExpand={props.displayActionButtons}
                                canRun={props.displayActionButtons ? props.isAdmin || checkOwner ? true : false : props.displayActionButtons}
                                isItemSelected={isItemSelected}
                                handleClick={(event) => props.selectable === "no" ? '' : handleClick(event, row)}
                                handleExpand={handleExpand}
                                handleView={handleLoaderView}
                                handleEdit={handleLoaderEdit}
                                handleDelete={confirmLoaderDelete}
                                deletedRows={deletedIds}
                                handleRun={confirmLoaderRun}
                                loadingIcon={deletePending}
                                deletedIdLoading={deletedIdLoading}
                                deleteId={deleteLoaderStatus ? deleteLoaderStatus[0].isDeleted : false}

                            >

                                <Box className="expand-details" sx={{ margin: 1 }}>
                                    <Grid container spacing={3}>
                                        <Grid item xs={6}>
                                            <div><span className="title">Name : </span><span>{details?.businessMetadata.description ?? "None"}</span></div>
                                            <div><span className="title">Schema : </span><span>{details?.technicalMetadata.schema ?? "None"}</span></div>
                                            <div><span className="title">Owner : </span><span>{details?.businessMetadata.owner ?? "None"}</span></div>
                                            <div><span className="title">Target ID : </span><span>{row.targetLayerId ?? "None"}</span></div>


                                        </Grid>
                                        <Grid item xs={6}>
                                            <div><span className="title">User Defined Filters : </span><span>{details?.technicalMetadata.userDefinedFilters ?? "None"}</span></div>
                                        </Grid>
                                    </Grid>
                                </Box>

                            </Row>
                        );
                    })}
                {emptyRows > 0 && emptyRows < 10 && (
                    <TableRow
                        style={{
                            height: (53) * emptyRows,
                        }}
                    >
                        <TableCell colSpan={6} />
                    </TableRow>
                )}
                {dataRows?.length < 1 && (
                    <TableRow
                        style={{
                            height: (53) * emptyRows,
                        }}
                    >
                        <TableCell colSpan={6}>There are no loaders available.</TableCell>
                    </TableRow>
                )}
            </>
        );
    }


    const listGrid = () => {

        return (
            <>
                {/* adding skeleton screen on loading */}
                {loadingLoaderList ?
                    <Grid container width="100%">
                        <Grid item xs={12}>
                            <Skeleton animation="wave" height={60} />
                        </Grid>
                        <Grid item xs={12}>
                            <Skeleton animation="wave" height={60} />
                        </Grid>
                        <Grid item xs={12}>
                            <Skeleton animation="wave" height={60} />
                        </Grid>
                        <Grid item xs={12}>
                            <Skeleton animation="wave" height={60} />
                        </Grid>
                        <Grid item xs={12}>
                            <Skeleton animation="wave" height={60} />
                        </Grid>
                        <Grid item xs={12}>
                            <Skeleton animation="wave" height={60} />
                        </Grid>
                        <Grid item xs={12}>
                            <Skeleton animation="wave" height={60} />
                        </Grid>
                        <Grid item xs={12}>
                            <Skeleton animation="wave" height={60} />
                        </Grid>
                    </Grid>

                    :
                    <EnhancedTable
                        totalRows={totalRows}
                        tableToolBar={tableToolBar()}
                        tableHeader={tableHeader()}
                        tableRows={tableRows()}
                        pagination={true}
                        page={page}
                        rowsPerPage={rowsPerPage}
                        handleChangePage={handleChangePage}
                        handleChangeRowsPerPage={handleChangeRowsPerPage}
                    />

                }
            </>
        );
    }

    return (
        <>
            <SearchListGrid searchEl={searchEl()} children={listGrid()} />
            {isDeletePopup || isRunPopup ? <CustomizedDialogs
                dialogHeight=''
                modalSize="md"
                key="target"
                modalTitle={isRunPopup ? "Run Loader" : "Delete Confirmation"}
                isOpen={open}
                onClose={handleClose}
                footerAction={
                    <Stack direction="row" spacing={2}>
                        {isDeletePopup ? <Button id="46d212db-bcb5-45af-9743-e7ad130f8f8c" color="primary" onClick={handleLoaderDelete} autoFocus>
                            Yes
                        </Button> : ''}
                        {isRunPopup ? <>
                            <Button id="d0e4e15d-a357-485d-91ab-161cdd66bcbc" color="primary" onClick={handleLoaderRun} autoFocus>
                                Run
                            </Button>
                            {isRebaseAllowed && <Button id="f9b4ca7e-0c4b-49d4-93de-5f49ba1dbb28" color="primary" onClick={handleLoaderRunRebase} autoFocus>
                                Run (Rebase)
                            </Button>}
                        </> : ''}
                        <Button id="102bd90d-10a9-43e4-b964-d3c06e7ed208" color="primary" onClick={handleClose}>
                            No
                        </Button>
                    </Stack>
                }
            >
                {isRunPopup ? <>Do you want to run the loader {rowName} with rebase?</> : <>Are you sure you want to delete {loaderBatchCode}? </>}
            </CustomizedDialogs> : ''}

        </>
    );

};

export default LoaderExplorer;